import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

// Suppress benign ResizeObserver loop warnings (Radix/Recharts) in dev overlay
if (typeof window !== "undefined") {
  const ignore = (msg) =>
    typeof msg === "string" && msg.includes("ResizeObserver loop");
  window.addEventListener("error", (e) => {
    if (ignore(e.message)) {
      e.stopImmediatePropagation();
      e.preventDefault();
    }
  });
  window.addEventListener("unhandledrejection", (e) => {
    if (ignore(e.reason?.message)) e.preventDefault();
  });
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);

// ---- Registro del Service Worker (PWA offline-resiliente) ----
if (typeof window !== "undefined" && "serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/sw.js", { scope: "/" })
      .then((reg) => reg.update().catch(() => {}))
      .catch((err) => {
        // En desarrollo (localhost no-HTTPS) puede fallar — no es crítico.
        // eslint-disable-next-line no-console
        console.warn("Service Worker no registrado:", err?.message || err);
      });
    // Cuando una nueva versión del SW toma el control, recarga una vez para
    // cargar el código nuevo (evita quedarse con una versión antigua cacheada)
    let swRefreshing = false;
    navigator.serviceWorker.addEventListener("controllerchange", () => {
      if (swRefreshing) return;
      swRefreshing = true;
      window.location.reload();
    });
  });
}
